// extracted by mini-css-extract-plugin
export default {"root":"product-operation-form-module_root-kTpLY"};